import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { moduleHref } from "@/mobile/open";

export default function MobileHome({ groups, section }) {
  const nav = useNavigate();
  const refs = useRef({});
  useEffect(() => {
    if (section && refs.current[section]) refs.current[section].scrollIntoView({ block: "start" });
  }, [section]);
  return (
    <div className="p-3 pb-6 space-y-4" data-testid="mobile-home">
      {groups.map((g) => (
        <section key={g.key} ref={(el) => { refs.current[g.key] = el; }} className="scroll-mt-2" data-testid={`mobile-section-${g.key}`}>
          <h2 className="text-[16px] font-bold mb-2 px-0.5" style={{ fontFamily: "Manrope" }}>{g.label}</h2>
          <div className="grid grid-cols-2 gap-2.5">
            {g.modules.map((m) => (
              <button key={m.to} type="button" onClick={() => nav(moduleHref(m))}
                className="min-h-[96px] text-left rounded-lg p-3 bg-[var(--m-card)] border border-[var(--m-border)] shadow-[0_1px_2px_rgba(15,17,17,0.06)] active:bg-[var(--m-skeleton)] flex flex-col"
                data-testid={`mobile-tile-${m.tid || m.to}`}>
                <span className="w-9 h-9 rounded-md flex items-center justify-center bg-[#4fc3f7]/15 text-[var(--m-accent-strong)]">
                  {m.icon && <m.icon className="w-5 h-5" strokeWidth={2} />}
                </span>
                <span className="mt-2 text-[14px] font-semibold leading-snug">{m.label}</span>
                <span className="mt-auto pt-1 text-[12px] text-[var(--m-link)] flex items-center gap-0.5">
                  {m.children?.length ? `${m.children.length} pages` : "Open module"}<ChevronRight className="w-3 h-3" />
                </span>
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
